import React from 'react';
import { Switch, Route } from 'react-router-dom';
import TackPauseContainer from '../containers/tack_pause';
import LoggedOutTackContainer from '../containers/logged_out_tack';
import LoggedOutTackConfirmationContainer from '../containers/logged_out_tack_confirmation';
import TackContainer from '../containers/tack';
import TackConfirmationContainer from '../containers/tack_confirmation';
import TackIntervalSelectionContainer from '../containers/tack_interval_selection';
import AllNewestWordsContainer from '../containers/all_newest_words';
import AllMostTackedWordsContainer from '../containers/all_most_tacked_words';
import TackPauseAllContainer from '../containers/tack_pause_all';
import TackResumeAllContainer from '../containers/tack_resume_all';

export default class Tacks extends React.Component {
  render() {
    return(
      <Switch>
        <Route path="/tacks/:tackSlug/selection/:tackIntervalSelectionMask" component={ TackIntervalSelectionContainer } />
        <Route path="/tacks/trends/most_tacked" component={ AllMostTackedWordsContainer } />
        <Route path="/tacks/trends/newest" component={ AllNewestWordsContainer } />
        <Route path="/tacks/logged_out/:wordText/:targetLanguage/confirmation" component={ LoggedOutTackConfirmationContainer } />
        <Route path="/tacks/logged_out/:wordText/:targetLanguage" component={ LoggedOutTackContainer } />
        <Route path="/tacks/logged_out/:wordText" component={ LoggedOutTackContainer } />
        <Route path="/tacks/:slug/pause" component={ TackPauseContainer } />
        <Route path="/tacks/:wordText/confirmation" component={ TackConfirmationContainer } />
        <Route path="/tacks/pause_all" component={ TackPauseAllContainer } />
        <Route path="/tacks/resume_all" component={ TackResumeAllContainer } />
        <Route path="/tacks/:wordText/:targetLanguage" component={ TackContainer } />
        <Route path="/tacks/:wordText" component={ TackContainer } />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/tacks.jsx